import {LoadingOverlay} from '@mantine/core';
import type {GetServerSideProps} from 'next';
import type {GetServerSidePropsResult} from 'next/types';
import {useGetExternalServices} from '../../../../core/repositories/externalServicesRepository';
import {
  type GetUserDataForAnalyticsResponseType,
  getUserDataForAnalytics,
} from '../../../../core/repositories/usersMeRepository';
import {LinkPage} from '../../../../features/externalServices/line/components/LinkPage';
import {UnlinkPage} from '../../../../features/externalServices/line/components/UnlinkPage';
import {withHandler} from '../../../../server/token/withHandler';
import {ScriptForGA} from '../../../../shared/components/ScriptForGA';
import {NoLeftSidebarLayout} from '../../../../shared/components/layouts/NoLeftSidebarLayout';
import type {NextPageWithLayout} from '../../../_app';

type Props = {
  userDataForAnalytics?: GetUserDataForAnalyticsResponseType;
};

export const getServerSideProps: GetServerSideProps = withHandler<
  Props,
  'withRequiredSession'
>(
  {auth: 'required'},
  async (context): Promise<GetServerSidePropsResult<Props>> => {
    const {cookies} = context.req;

    const userDataResponse = await getUserDataForAnalytics({cookies});
    if (!userDataResponse.ok) {
      return {
        props: {},
      };
    }

    return {
      props: {
        userDataForAnalytics: userDataResponse.value,
      },
    };
  },
);

const LineSetting: NextPageWithLayout<Props> = ({userDataForAnalytics}) => {
  const {data, isLoading} = useGetExternalServices({});
  const isAssociated = data?.ok && data?.value.line.isAssociated;

  return (
    <>
      <LoadingOverlay visible={isLoading} overlayBlur={2} />
      {isAssociated ? <UnlinkPage /> : <LinkPage />}
      <ScriptForGA userDataForAnalytics={userDataForAnalytics} />
    </>
  );
};

export default LineSetting;

LineSetting.getLayout = (page) => (
  <NoLeftSidebarLayout>{page}</NoLeftSidebarLayout>
);
